import React, { useState, useEffect } from "react";
import { Tabs, Affix } from "antd"; 
import { Route, Switch, useHistory, useLocation, Redirect } from "react-router-dom";
import CandidateList from "./CandidateList";
import CareerBuilderCandidates from "./CareerBuilderCandidates";
import MonsterCandidates from "./MonsterCandidates";
import LinkedInCandidates from "./LinkedInCandidates";
import AutoSourceCandidates from "./AutoSourceCandidates";
import MonsterSearch from '../../../../monster/v2/components';
import CBSearchV2 from '../../../../CBSearch/v2/components';
import { JobBoardSearchProvider as MonsterJobBoardSearchProvider } from '../../../../monster/v2/context/searchContext';
import { JobBoardSearchProvider as CBJobBoardSearchProvider } from '../../../../CBSearch/v2/context/searchContext';

// Define CareerBuilderCandidatesV2 to point to the CBSearchV2 component
const CareerBuilderCandidatesV2 = CBSearchV2;

const { TabPane } = Tabs;

const generateTabKeys = (userType) => ({
  internal: `/${userType}/candidateList/internal`,
  careerBuilder: `/${userType}/candidateList/career-builder`,
  careerBuilderV2: `/${userType}/candidateList/career-builderV2`,
  monster: `/${userType}/candidateList/monster`,
  monsterV2: `/${userType}/candidateList/monsterV2`,
  linkedin: `/${userType}/candidateList/linkedin`,
  autoSource: `/${userType}/candidateList/auto-source`,
});

export default function CandidatesPlatforms({ props }) {
  const history = useHistory();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("internal");
  const userType = props?.type || "user";
  const tabKeys = generateTabKeys(userType);

  useEffect(() => {
    const path = location.pathname;
    // Only set active tab if we're at the root path of a tab
    const currentTab = Object.keys(tabKeys).find(
      (key) => {
      const tabPath = tabKeys[key];
      return path === tabPath || path.startsWith(`${tabPath}/`);
    }
    );
    
    if (currentTab) {
      setActiveTab(currentTab);
    }
  }, [location, tabKeys]);

  const handleTabChange = (key) => {
    setActiveTab(key);
    // Only navigate if we're changing tabs
    if (key !== activeTab) {
      history.push(tabKeys[key]);
    }
  };

  return (
    <div>
      <Affix offsetTop={0}>
        <div
          style={{
            backgroundColor: "white",
            padding: "8px 16px",
            borderBottom: "1px solid #f0f0f0",
          }}
        >
          <Tabs
            activeKey={activeTab}
            onChange={handleTabChange}
            tabPosition="top"
            style={{ marginBottom: 0 }}
          >
            <TabPane tab="Candidates List" key="internal" />
            <TabPane tab="Career Builder" key="careerBuilder" />
            <TabPane tab="Career Builder V2" key="careerBuilderV2" />
            <TabPane tab="Monster Search" key="monster" />
            <TabPane tab="Monster Search V2" key="monsterV2" />
            <TabPane tab="LinkedIn" key="linkedin" />
            <TabPane tab="Auto Source" key="autoSource" />
          </Tabs>
        </div>
      </Affix>

      <Switch>
        <Route
          exact
          path={`/${userType}/candidateList`}
          render={() => <Redirect to={tabKeys.internal} />}
        />
        <Route
          path={tabKeys.internal}
          render={() => <CandidateList props={props} />}
        />
        <Route
          path={tabKeys.monster}
          render={() => <MonsterCandidates type={props?.type || "admin"} />}
        />
          <Route
            path={`${tabKeys.monsterV2}`}
            render={() => (
              <MonsterJobBoardSearchProvider>
                <Switch>
                  <Route exact path={tabKeys.monsterV2} component={MonsterSearch} />
                  <Route path={`${tabKeys.monsterV2}/results`} component={MonsterSearch} />
                  <Route path={`${tabKeys.monsterV2}/compare`} component={MonsterSearch} />
                </Switch>
              </MonsterJobBoardSearchProvider>
            )}
          />
        <Route
          path={tabKeys.autoSource}
          render={() => <AutoSourceCandidates type={props?.type || "admin"} />}
        />
        <Route
          path={tabKeys.careerBuilder}
          component={CareerBuilderCandidates}
        />
        <Route 
          path={`${tabKeys.careerBuilderV2}`}
          render={() => (
            <CBJobBoardSearchProvider>
              <Switch>
                <Route exact path={tabKeys.careerBuilderV2} component={CareerBuilderCandidatesV2} />
                <Route path={`${tabKeys.careerBuilderV2}/results`} component={CareerBuilderCandidatesV2} />
                <Route path={`${tabKeys.careerBuilderV2}/compare`} component={CareerBuilderCandidatesV2} />
              </Switch>
            </CBJobBoardSearchProvider>
          )}
        />
        <Route
          path={tabKeys.linkedin}
          component={LinkedInCandidates}
        />
      </Switch>
    </div>
  );
}
